import { FragmentStore } from '../runtime/stores/fragment'
import artifact from '$houdini/artifacts/SerialOptionValues'


// create the fragment store

export class SerialOptionValuesStore extends FragmentStore {
	constructor() {
		super({
			artifact,
			storeName: "SerialOptionValuesStore",
			variables: true,
			
		})
	}
}
